import {AssetImporter} from "@app/components/AssetImporter"
import {CanvasSkeleton} from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton"

export const MobileSkeletonBanner = () => {
    return (
        <CanvasSkeleton className="flex items-center justify-center h-52 w-full rounded-none">
            <AssetImporter name="logoV" className="h-10 text-input"/>
        </CanvasSkeleton>
    );
}